var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('a',{staticClass:"mr-2",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.show()}}},[_c('Icon',{attrs:{"name":"notificationMessage","width":"24"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }